/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Injectable } from "@angular/core";
import { REST_CONSTANTS } from "../utils/data.rest.constants";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class StatementService {
  constructor(private http: HttpClient) {}

  getLogoImage(merchantId: number): Observable<Blob> {
    const url = `${REST_CONSTANTS.MERCHANT_BASE_URL}/merchants/${merchantId}/logo`;
    return this.http
      .get<Blob>(url, {
        headers: new HttpHeaders({ Accept: "application/json, text/plain, */*" }),
        responseType: "blob" as "json"
      })
      .pipe(catchError(StatementService.handleError));
  }

  getStatementOptions(merchantId: number): Observable<{ [index: string]: string }> {
    const url = `${REST_CONSTANTS.MERCHANT_OLD_BASE_URL}/merchants/${merchantId}/statements`;
    return this.http
      .get<{ [index: string]: string }>(url, { headers: REST_CONSTANTS.JSON_HEADER })
      .pipe(catchError(StatementService.handleError));
  }

  updateStatementOptions(
    merchantId: number,
    statementOptions: { [index: string]: string }
  ): Observable<{ [index: string]: string }> {
    const url = `${REST_CONSTANTS.MERCHANT_OLD_BASE_URL}/merchants/${merchantId}/statements`;
    return this.http
      .put<{ [index: string]: string }>(url, statementOptions, { headers: REST_CONSTANTS.JSON_HEADER })
      .pipe(catchError(StatementService.handleError));
  }

  uploadLogo(merchantId: number, imageMetadata: any) {
    const url = `${REST_CONSTANTS.MERCHANT_BASE_URL}/merchants/${merchantId}/logo`;

    const data = new FormData();
    data.append("logo", imageMetadata);

    return this.http
      .put(url, data, {
        headers: new HttpHeaders({
          "Content-Disposition": 'filename="' + imageMetadata.name + '"'
        })
      })
      .pipe(catchError(StatementService.handleError));
  }

  private static handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
}
